export default __webpack_public_path__ + "static/media/chart@3x.b4ec0db8.png";